import { render, staticRenderFns } from "./FileFormatOptionsEditor.vue?vue&type=template&id=86ffdf8e&scoped=true&"
import script from "./FileFormatOptionsEditor.vue?vue&type=script&lang=js&"
export * from "./FileFormatOptionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./FileFormatOptionsEditor.vue?vue&type=style&index=0&id=86ffdf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ffdf8e",
  null
  
)

export default component.exports